export default __webpack_public_path__ + "static/media/right-circle.a9ecfd82.svg";